import { DocumentMyDeskResponse } from "apis/data-contracts";
import {
  CancelIcon,
  FileCheckIcon,
  FileLockIcon,
  HourglassIcon,
} from "assets/icons";
import { ComponentType } from "react";

export type MyDeskStatusFilterValue = DocumentMyDeskResponse["status"] | " ";

type SummaryCountKey =
  | "approveInProgressCount"
  | "approveCount"
  | "reqSupplementCount"
  | "tempCount";

type SummaryTone = "pending" | "approved" | "supplement" | "temp";

type IconComponent = ComponentType;

export const documentStatusList: {
  label: string;
  value: MyDeskStatusFilterValue;
}[] = [
  {
    label: "전체",
    value: " ",
  },
  {
    label: "결재대기 / 요청",
    value: "APPROVE_IN_PROGRESS",
  },
  {
    label: "결재완료",
    value: "APPROVE",
  },
  {
    label: "보완요청 / 필요",
    value: "REQ_SUPPLEMENT",
  },
  {
    label: "임시저장",
    value: "TEMP",
  },
];

export const analysisDocumentStatusList: {
  label: string;
  value: MyDeskStatusFilterValue;
}[] = [
  {
    label: "전체",
    value: " ",
  },
  {
    label: "1단계 결재대기 / 요청",
    value: "REVIEW_IN_PROGRESS",
  },
  {
    label: "1단계 결재완료",
    value: "REVIEW",
  },
  {
    label: "2단계 결재대기 / 요청",
    value: "APPROVE_IN_PROGRESS",
  },
  {
    label: "결재완료",
    value: "APPROVE",
  },
  {
    label: "보완요청 / 필요",
    value: "REQ_SUPPLEMENT",
  },
  {
    label: "임시저장",
    value: "TEMP",
  },
];

export const myDeskStatusSummaryItems: {
  label: string;
  value: DocumentMyDeskResponse["status"];
  countKey: SummaryCountKey;
  tone: SummaryTone;
  icon: IconComponent;
}[] = [
  {
    label: "결재대기",
    value: "APPROVE_IN_PROGRESS",
    countKey: "approveInProgressCount",
    tone: "pending",
    icon: HourglassIcon,
  },
  {
    label: "결재완료",
    value: "APPROVE",
    countKey: "approveCount",
    tone: "approved",
    icon: FileCheckIcon,
  },
  {
    label: "보완요청",
    value: "REQ_SUPPLEMENT",
    countKey: "reqSupplementCount",
    tone: "supplement",
    icon: CancelIcon,
  },
  {
    label: "임시저장",
    value: "TEMP",
    countKey: "tempCount",
    tone: "temp",
    icon: FileLockIcon,
  },
];

export const normalizeMyDeskDocumentStatus = (
  value: MyDeskStatusFilterValue,
): DocumentMyDeskResponse["status"] | undefined => {
  if (value === " ") return undefined;

  return value;
};
